import firebase from "firebase";
import { database } from "../app-database";
import { saveAs } from "file-saver";

import { callService } from "../tools";
import { servicios } from "./../properties";

const refTramitesListado = database.ref("/tramites");
const refCirugiasListado = database.ref("/catalogos/cirugias");
const refCondicionesGralListado = database.ref("/catalogos/condiciones-generales-pdfs");

const urlBASE = servicios.formatos.listaBlanca;

export const tramitesCarga = () => {
	return dispatch => {
		refTramitesListado.once("value", snapshot => {
			let data = snapshot.val();
			let tramitesListado = [];
			
			Object.keys(data).map((item,i) => {
				tramitesListado.push(data[item]);
			});

			dispatch({ "type": "TRAMITES_LLENAR", "listado": tramitesListado });
		}, reason => {
			throw reason;
		});
	};
};

export const cirugiasCarga = () => {
	return dispatch => {
		refCirugiasListado.once("value", snapshot => {
			let data = snapshot.val();
			let listado = [];
			
			Object.keys(data).map((item,i) => {
				listado.push(data[item]);
			});

			dispatch({ "type": "TRAMITES_LLENAR_CIRUGIAS", "cirugias": listado });
		}, reason => {
			throw reason;
		});
	};
};

export const condicionesGralCarga = () => {
	return dispatch => {
		refCondicionesGralListado.once("value", snapshot => {
			let data = snapshot.val();
			let listado = [];
			
			Object.keys(data).map((item,i) => {
				listado.push(data[item]);
			});

			dispatch({ "type": "TRAMITES_LLENAR_CONDICIONES_GENERALES", "condiciones_generales": listado });
		}, reason => {
			throw reason;
		});
	};
};

export const cargarRetenciones = sAnio => {
	return dispatch => {
		dispatch({ "type": "RETENCIONES_LIMPIAR" });
		dispatch({ "type": "LOADER_SHOW" });
		
		let request ={};
		
		if (sAnio != "todos") {
			request.anio = sAnio;
		}
		
		let llamadaSeguro = new callService({
			service: "retenciones.listadoRetenciones",
			"secure": true,
			data: request,
			json:true
		}).execute().then(body=>{
			if(body.hasOwnProperty("error")){

			} else {
				dispatch({ "type": "LOADER_HIDE" });
				dispatch({
					"type": "RETENCIONES_LLENAR",
					"retenciones": body
				});
			}
		}).catch(() => {
			dispatch({ "type": "LOADER_HIDE" });
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Importante", "mensaje": "Por el momento no es posible mostrar la documentación. Por favor, contacte a su Asesor Profesional en Seguros para solicitar la información." });
		});
	};
};

export const descargarRetencion = (idDocumentum, sTipo) => {
	return dispatch => {
		let sArchivo = "Retencion." + sTipo;
		dispatch({ "type": "DESCARGAS_LISTA_ADD", "descarga": {"id": idDocumentum, "nombre": sArchivo, "completo": 0} });
		
		let request ={
			"id": idDocumentum
		};
		
		let llamadaSeguro = new callService({
			service: "retenciones.descargaRetencion",
			"secure": true,
			data: request,
			json:true
		}).execute().then(body=>{
			if(body.hasOwnProperty("error")){

			} else {
				dispatch({ "type": "LOADER_HIDE" });
				dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": {"id": idDocumentum, "nombre": sArchivo, "completo": 100} });
				download(body.attachment, sArchivo);
			}
		}).catch(() => {
			dispatch({ "type": "LOADER_HIDE" });
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Importante", "mensaje": "Por el momento no es posible mostrar la documentación. Por favor, contacte a su Asesor Profesional en Seguros para solicitar la información." });
			dispatch({ "type": "DESCARGAS_LISTA_UPDATE", "descarga": {"id": idDocumentum, "nombre": sArchivo, "completo": 100, "error": true} });
		});
	};
};

export const testDos = () => {
	return dispatch => {
		let url = "";
		url = urlBASE;

		$.ajax({
			method: "GET",
			url: url,
			dataType: "json",
			success: (data) => {
				console.log(">>>Respuesta SERV",data);
				dispatch({ "type": "TRAMITES_LISTA_BLANCA", "lista_blanca_state": data });
			},
			error: (error) => {
				dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": true });
			}
        });
	};
};

function download(base64Data, sArchivo, bZip) {
	var arrBuffer = base64ToArrayBuffer(base64Data);

	// It is necessary to create a new blob object with mime-type explicitly set
	// otherwise only Chrome works like it should
	var newBlob;
	if (bZip) {
		newBlob = new Blob([arrBuffer], { type: "application/zip" });
	} else {
		newBlob = new Blob([arrBuffer], { type: "application/pdf" });
	}
	console.log(newBlob);

	// IE doesn't allow using a blob object directly as link href
	// instead it is necessary to use msSaveOrOpenBlob
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		window.navigator.msSaveOrOpenBlob(newBlob);
		return;
	}
	saveAs(newBlob, sArchivo);
	// For other browsers:
	// Create a link pointing to the ObjectURL containing the blob.
	// var data = window.URL.createObjectURL(newBlob);
	// console.log(data);
	// var link = document.createElement('a');
	// document.body.appendChild(link); //required in FF, optional for Chrome
	// link.href = data;
	// link.download = "file.pdf";
	// link.target = "_blank";
	// link.click();
	// window.URL.revokeObjectURL(data);
	// link.remove();
}

function base64ToArrayBuffer(data) {
	var binaryString = window.atob(data);
	var binaryLen = binaryString.length;
	var bytes = new Uint8Array(binaryLen);
	for (var i = 0; i < binaryLen; i++) {
		var ascii = binaryString.charCodeAt(i);
		bytes[i] = ascii;
	}
	return bytes;
}


// WEBPACK FOOTER //
// ./src/mis-tramites/misTramites.act.js